import React, { useEffect, useContext, useState } from "react";
import AppContext from "../util/AppContext";
import ReactFullpage from "@fullpage/react-fullpage";
import GotQueries from "../components/GotQueries/GotQueries";
import "./Home.css";
import "../components/Cred/Cred.css";
import WhoAreYou from "../components/WhoAreYou/WhoAreYou";
import Carousel from "../components/Carousel/Carousel";

import corner from "../assets/corner.png";
import cornerTR from "../assets/cornerTR.png";
import cornerBR from "../assets/cornerBR.png";
import cornerBL from "../assets/cornerBL.png";
import collaborate from "../assets/cred/collaborate.gif";
import productive from "../assets/cred/productive.gif";
import underoneroof from "../assets/cred/underoneroof.gif";
import ig from "../assets/footer-social/ig.png";
import linkedin from "../assets/footer-social/linkedin.png";
import twitter from "../assets/footer-social/twitter.png";
import seperator from "../assets/seperator.png";
import locationMarker from "../assets/footer-social/location.png";
import vector from "../assets/cred/vector.png";
import CardHolder from "../components/CardHolder/CardHolder";
import CredMobile from "../components/CredMobile/CredMobile";
import Footer from "../components/Footer/Footer";
import Cred from "../components/Cred/Cred";

const anchors = [
  "first",
  "second",
  "third",
  "fourth",
  "fifth",
];

const Home = () => {
  const myContext = useContext(AppContext);
  const [page, setPage] = useState('home');

  return (
    <ReactFullpage
      anchors={anchors}
      responsiveWidth={1199}
      scrollOverflow={true}
      normalScrollElements=".cred-description"
      navigation
      navigationTooltips={anchors}
      onLeave={(origin, destination, direction) => { }}
      render={({ state, fullpageApi }) => {
        // fullpageApi.setAllowScrolling(false);

        return (
          <ReactFullpage.Wrapper>
            <div className="section first">
              <GotQueries />
              <div className="container-fluid" id="hero-container-fluid">
                <div className="container" id='hero-container'>
                  <div className="row hero-row">
                    <div
                      className="col-xl-5 col-lg-8 col-md-12 col-sm-12 col-12">
                      <div className="hero-card">
                        <div className="content">
                          <p className="hero-card-title">
                            your own <br /> metaverse to work!
                          </p>
                          <p className="hero-card-description">
                            your community now functions better & builds
                            stronger bonds with shared experiences on the revirt
                            metaverse!
                          </p>
                          <button className="hero-card-button">
                            get started &gt;
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Carousel mode='dark' />
              </div>
            </div>
            <CardHolder page="home" />
            {window.innerWidth < 1199 ? (
              <CredMobile />
            ) : (
              <div className="section third cred">
                <Cred page={page}/>
              </div>
            )}

            <div className="section fourth">
              <div className="fourth-inside">
                <WhoAreYou />
              </div>
            </div>
            <Footer page='home' />
            {/* <div className="section footer">
              <div className="container-fluid">
                <div className="footer-inside container">
                  <div className="row justify-content-center">
                    <div className="col-xl-6 col-lg-8 col-md-12 col-sm-12 col-12 footer-banner">
                      <img src={corner} alt="" id="topleft" />
                      <img src={cornerTR} alt="" id="topright" />
                      <img src={cornerBR} alt="" id="bottomright" />
                      <img src={cornerBL} alt="" id="bottomleft" />
                      <p className="footer-heading">try revirt for free</p>
                      <button className="get-started-footer">
                        get started
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="container-fluid social-footer">
                <div className="container">
                  <div className="row justify-content-center gy-3">
                    <div
                      className="col-xl-2 col-lg-2 col-md-3 col-sm-12 col-12"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div className="footer-policy-links">
                        <p>privacy policy</p>
                        <p>terms of use</p>
                      </div>
                      {window.innerWidth > 767 ? (
                        <div>
                          <img src={seperator} alt="" className="seperator" />
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                    <div
                      className="social-footer-icons-container col-xl-2 col-lg-2 col-md-3 col-sm-12 col-12"
                    >
                      <img src={ig} alt="" />
                      <div className="icons-container-1">
                        <img src={twitter} alt="" />
                      </div>
                      <div className="icons-container-2">
                        <img src={linkedin} alt="" />
                      </div>
                      {window.innerWidth > 767 ? (
                        <div>
                          <img src={seperator} alt="" className="seperator" />
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                    <div
                      className="col-xl-2 col-lg-2 col-md-3 col-sm-12 col-12 contact-footer-col"
                    >
                      <p className="contact-footer">contact</p>
                      <p className="email-footer">office@revirt.space</p>
                    </div>
                    <div
                      className="col-xl-6 col-lg-6 col-md-3 col-sm-12 col-12 locationcol col-12">
                      <img src={locationMarker} alt="" className="locationIcon"/>
                      &nbsp;&nbsp;&nbsp;
                      <p>from our offices in the revirt metaverse</p>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </ReactFullpage.Wrapper>
        );
      }}
    />
  );
};

export default Home;
